module.exports = __webpack_public_path__ + "static/media/arrowDown.894eaa50.svg";